// @ts-strict-ignore
import type { AdSlot, Dictionary } from '../models';
import { slotService } from './slot-service';
import { templateService } from './template-service';
import { communicationService } from '@ad-engine/communication';
import { AD_ENGINE_UAP_CUSTOM_LOADER_CALLED } from '../../communication/events/events-ad-engine-uap';

export function registerCustomAdLoader(methodName: string | undefined): void {
	if (methodName) {
		window[methodName] = (params: Dictionary) => {
			const slot: AdSlot | null = params?.slotName ? slotService.get(params.slotName) : null;
			templateService.init(params?.type ?? 'bfaa', slot, params);
			communicationService.emit(AD_ENGINE_UAP_CUSTOM_LOADER_CALLED, params);
		};
	}
}
